import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import { Outlet } from "react-router";
// import Construccion from "./Screens/HomeScreen_Construccion";
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <div className="site-wrapper">
      <ScrollToTop />
      {/* <Construccion /> */}
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default App;